<style scoped lang="less">
</style>

<template>
    <router-view/>
</template>

<script>
export default {
    props: {},
    components: {},
    data() {
        return {};
    },
    created() {},
    mounted() {},
    computed: {},
    watch: {},
    methods: {}
};
</script>
